import classNames from "classnames/bind";
import styles from "./Post.module.scss";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { useEffect, useState } from "react";
import { fetchPost } from "../../../redux/slice/postSlice";
import FormatTime from "../../../utils/formatTime";
import { useNavigate } from "react-router-dom";
import AsidePost from "../../components/AsidePost/AsidePost";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import { callLikePost } from "../../../config/api";
import { fetchAccount } from "../../../redux/slice/accountSlide";
import { Button, Card, message } from "antd";
import ModalComment from "./Modal/ModalComment";
import ModalShare from "./Modal/ModalShare";
import ImgDefault from "../../../assets/images/ngocrong.png";
import { DownOutlined } from "@ant-design/icons";

const css = classNames.bind(styles);

const Post = () => {
  const { result: posts, isFetching: LoadingPost } = useAppSelector(
    (state) => state.post
  );
  const user = useAppSelector((state) => state.account.user);
  const [pageSize, setPageSize] = useState(6);
  const [page] = useState(1);
  useEffect(() => {
    dispatch(fetchAccount());

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  let query = `current=${page}&pageSize=${pageSize}&sort=-createdAt`;
  query += "&populate=categoryId&fields=categoryId._id,categoryId.name";

  const handleFetchPost = () => {
    dispatch(fetchPost({ query }));
  };
  useEffect(() => {
    handleFetchPost();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  const handleDetailPost = (item: any) => {
    navigate(`/post-detail/${item}`);
  };
  const handleLikePost = async (postId: string) => {
    const res = await callLikePost(postId);
    if (res.statusCode === 200) {
      handleFetchPost();
    } else {
      message.warning("Bạn chưa đăng nhập tài khoản!");
    }
  };

  return (
    <div className={css("wrapper")}>
      <div className={css("wrapper-home")}>
        <div>
          {posts && posts.length > 0 ? (
            posts.map((item: any, index) => {
              return (
                <div key={index} className={css("container")}>
                  <div>
                    <img
                      className={css("img-header")}
                      src={item?.image}
                      alt="no avatar"
                    />
                    <div className={css("title")}>
                      <img
                        src={
                          item.createdBy?.avatar
                            ? item.createdBy?.avatar
                            : ImgDefault
                        }
                        alt="avatar"
                      />
                      <div className={css("title-text")}>
                        <ul>
                          <li>{item.createdBy?.name}</li>
                          <li>
                            <FormatTime time={item.createdAt} />
                          </li>
                        </ul>
                        <h5>Bài viết về {item?.categoryId?.name}</h5>
                      </div>
                    </div>
                  </div>
                  <div className={css("content")}>
                    <h3
                      className={css("title-content")}
                      onClick={() => handleDetailPost(item._id)}>
                      {item.title}
                    </h3>
                  </div>
                  <div
                    className={css("see-more")}
                    onClick={() => handleDetailPost(item._id)}>
                    Xem thêm
                  </div>
                  <div className={css("section-last")}>
                    <div
                      className={css("action-like")}
                      onClick={() => handleLikePost(item._id)}>
                      <FontAwesomeIcon
                        icon={faHeart}
                        size="1x"
                        color={item.likes.length > 0 ? "#ea4335" : "#000"}
                      />
                      <span>{item.likes.length}</span>
                    </div>
                    {/* user comment */}
                    <ModalComment
                      postId={item._id}
                      avatar={user?.avatar}
                      author={user?.name}
                    />
                    <ModalShare postId={item._id} />
                  </div>
                </div>
              );
            })
          ) : (
            <>
              <div
                style={{ display: "flex", flexDirection: "column", gap: 20 }}>
                <Card loading={true}></Card>
                <Card loading={true}></Card>
                <Card loading={true}></Card>
              </div>
            </>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}>
            <Button
              className={css("btn-see-more")}
              loading={LoadingPost}
              onClick={() => setPageSize((prev) => prev + 6)}>
              Xem thêm <DownOutlined />
            </Button>
          </div>
        </div>
        <div className={css("aside-post")} style={{ width: "100%" }}>
          <AsidePost />
        </div>
      </div>
    </div>
  );
};

export default Post;
